import React, { useContext } from "react";
import { Card, Col, Row } from "react-bootstrap";

import { ItemLookupContext } from "../../ItemLookupPage";
import imageNotFound from "../../../../assets/img/imageNotFound.png";

const ItemFnSkuToAsinResult = () => {
  const { asinInfo } = useContext(ItemLookupContext);

  return (
    <Row className="justify-content-center">
      {asinInfo.map((item, index) => (
        <Col key={`${item?.asin || "asin"}-${index}`}>
          <Card className="h-100 shadow-sm" bg="light" border="secondary">
            <Card.Body className="d-flex flex-column align-items-center text-center">
              <Card.Title>
                ASIN:
                {" " + (item?.asin || "N/A")}
              </Card.Title>
              <small>
                {item?.itemName || item?.title || "No title available"}
              </small>
              <img
                src={item.imageLink || imageNotFound}
                alt={item?.itemName || item?.title || item?.asin || "ASIN item"}
                style={{
                  maxHeight: "80px",
                  maxWidth: "100%",
                  objectFit: "contain",
                }}
              />
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default ItemFnSkuToAsinResult;
